<template>
  <div class="visibility-status">
    <div class="visibility-status__label">
      {{ $t("message.posts.storeLocator.visibilityStatus") }}
    </div>
    <div class="visibility-status__switch">
      <ui-switch
        v-model="localValue.visible_in_store_locator"
        :label="$t('message.posts.postVisibility')"
        color="cyan"
        @change="toggleVisibility"
      />
    </div>
  </div>
</template>

<script>
import serviceHandler from "@/helpers/handlers/service";
import postsService from "@/services/gmbPosts";

export default {
  name: "PostListItemStoreLocatorVisibility",
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localValue: null
    };
  },
  computed: {
    isVisible() {
      return this.localValue.visible_in_store_locator;
    }
  },
  created() {
    this.localValue = { ...this.post };
  },
  methods: {
    toggleVisibility() {
      serviceHandler(
        postsService.setStoreLocatorVisibility(this.post.id, this.isVisible)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.visibility-status {
  border-top: 1px solid $light-3;
  padding-top: $spacing * 2;

  &__label {
    @include font-size(12px);
    font-weight: bold;
    line-height: 17px;
    color: $dark-blue-3;
    margin-bottom: $spacing;
  }
}
</style>
